import { render, staticRenderFns } from "./trigger-form-submit.vue?vue&type=template&id=420d84ad&"
import script from "./trigger-form-submit.vue?vue&type=script&lang=js&"
export * from "./trigger-form-submit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports